export const PORTFOLIO_BLOCK_LAYOUT_BUTTON = 'fv--portfolio-block-layout-button';
export const PORTFOLIO_DETAIL_LAYOUT_BUTTON = 'fv--portfolio-details-layout-button';
export const PORTFOLIO_COVER_SHEET_LAYOUT_BUTTON = 'fv--portfolio-cover-sheet-layout-button';

export const PORTFOLIO_PREVIEW_RIGHT_SIDE_BUTTON = 'fv--portfolio-preview-right-side-button';
export const PORTFOLIO_PREVIEW_bOTTOM_SIDE_BUTTON = 'fv--portfolio-preview-bottom-side-button';
export const PORTFOLIO_PREVIEW_OFF_BUTTON = 'fv--portfolio-preview-off-button';

export const PORTFOLIO_DEFAULT_ORIGINAL_LAYOUT_BUTTON = 'fv--portfolio-default-original-layout-button';
export const PORTFOLIO_DEFAULT_BLOCK_LAYOUT_BUTTON = 'fv--portfolio-default-block-layout-button';
export const PORTFOLIO_DEFAULT_DETAIL_LAYOUT_BUTTON = 'fv--portfolio-default-details-layout-button';
export const PORTFOLIO_DEFAULT_COVER_SHEET_LAYOUT_BUTTON = 'fv--portfolio-default-cover-sheet-layout-button';

export const PORTFOLIO_ADD_FILES_BUTTON = 'fv--portfolio-add-files-button';
export const PORTFOLIO_CREATE_FOLDER_BUTTON = 'fv--portfolio-create-folder-button';
export const PORTFOLIO_REGENERATE_TOC_BUTTON = 'fv--portfolio-regenerate-toc-button';
export const PORTFOLIO_EXTRACT_BUTTON = 'fv--portfolio-extract-contextmenu-item';
export const PORTFOLIO_SHOW_INFORMATION_BUTTON = 'fv--portfolio-show-information-contextmenu-item';
export const PORTFOLIO_DELETE_BUTTON = 'fv--portfolio-delete-contextmenu-item';
export const PORTFOLIO_PROPERTIES_BUTTON = 'fv--portfolio-properties-contextmenu-item';
export const PORTFOLIO_PREVIEW_PREVIOUS_BUTTON = 'fv--portfolio-preview-previous-button';
export const PORTFOLIO_PREVIEW_NEXT_BUTTON = 'fv--portfolio-preview-next-button';

export const PORTFOLIO_LIST = [
    PORTFOLIO_BLOCK_LAYOUT_BUTTON,
    PORTFOLIO_DETAIL_LAYOUT_BUTTON,
    PORTFOLIO_COVER_SHEET_LAYOUT_BUTTON,
    PORTFOLIO_PREVIEW_RIGHT_SIDE_BUTTON,
    PORTFOLIO_PREVIEW_bOTTOM_SIDE_BUTTON,
    PORTFOLIO_PREVIEW_OFF_BUTTON,
    PORTFOLIO_DEFAULT_ORIGINAL_LAYOUT_BUTTON,
    PORTFOLIO_DEFAULT_BLOCK_LAYOUT_BUTTON,
    PORTFOLIO_DEFAULT_DETAIL_LAYOUT_BUTTON,
    PORTFOLIO_DEFAULT_COVER_SHEET_LAYOUT_BUTTON,
    PORTFOLIO_ADD_FILES_BUTTON,
    PORTFOLIO_CREATE_FOLDER_BUTTON,
    PORTFOLIO_REGENERATE_TOC_BUTTON,
    PORTFOLIO_EXTRACT_BUTTON,
    PORTFOLIO_SHOW_INFORMATION_BUTTON,
    PORTFOLIO_DELETE_BUTTON,
    PORTFOLIO_PROPERTIES_BUTTON,
    PORTFOLIO_PREVIEW_PREVIOUS_BUTTON,
    PORTFOLIO_PREVIEW_NEXT_BUTTON,
]